import {ContentContainer} from '@coolcolduk/ui-mui';
import PageHeader from '../../../components/PageHeader';
import QuestionStatusCounts from '../../../components/QuestionStatusCounts/QuestionStatusCounts';
import {PrivateRouteProps} from '../../../config/routeType';
import AdminQuestionReviewActions from './AdminQuestionReviewActions';
import useAdminQuestionReviewPage from './useAdminQuestionReviewPage';

/**
 * use to find list of questions to review
 * - show filter box to filter questions
 * - click go button will visit AdminQuestionReviewQuestionPage
 */
export default function AdminQuestionReview({user}: PrivateRouteProps) {
  const {
    QuestionFiltersComponent,
    handleNavigateToQuestionReview,
    handleCountQuestions,
    countLoading,
    questionCounts,
    isAdmin,
    isReviewer,
  } = useAdminQuestionReviewPage(user);

  return (
    <ContentContainer data-testid="admin-question-review-page">
      <PageHeader title="Question Review" />

      <QuestionFiltersComponent>
        <AdminQuestionReviewActions
          onNavigateToQuestionReview={handleNavigateToQuestionReview}
          onCountQuestions={handleCountQuestions}
          countLoading={countLoading}
          showCountButton={!isReviewer || isAdmin}
        />
      </QuestionFiltersComponent>

      {questionCounts && <QuestionStatusCounts questionCounts={questionCounts} />}
    </ContentContainer>
  );
}
